import Vue from 'vue';

export default {
  data() {
    return {
      loading: false,
      self: null,
      isAdmin: false,
    };
  },

  methods: {
    getInvitee(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(vue.$http.get('/api/invitee'),
        then, onError, setLoading);
    },

    patchInvitee(vue, id, patch, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.patch(`/api/invitee/${id}`, patch),
        then, onError, setLoading,
      );
    },

    getWishlist(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get('/api/wishlist/'),
        then, onError, setLoading,
      );
    },

    claimWishlistItem(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.post(`/api/wishlist/${id}/claim`),
        then, onError, setLoading,
      );
    },

    unclaimWishlistItem(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.post(`/api/wishlist/${id}/unclaim`),
        then, onError, setLoading,
      );
    },

    searchTracks(vue, search, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const enc = encodeURIComponent(search);

      this.processPromise(
        vue.$http.get(`/api/songs/search?name=${enc}`),
        then, onError, setLoading,
      );
    },

    searchArtists(vue, search, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const enc = encodeURIComponent(search);

      this.processPromise(
        vue.$http.get(`/api/songs/search?name=${enc}&search_type=artist`),
        then, onError, setLoading,
      );
    },

    searchAlbums(vue, search, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const enc = encodeURIComponent(search);

      this.processPromise(
        vue.$http.get(`/api/songs/search?name=${enc}&search_type=album`),
        then, onError, setLoading,
      );
    },

    searchAlbumsForArtist(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/songs/artist/${id}/albums`),
        then, onError, setLoading,
      );
    },

    searchTopTracksForArtist(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/songs/artist/${id}/top_tracks`),
        then, onError, setLoading,
      );
    },

    searchTracksForAlbum(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/songs/album/${id}/tracks`),
        then, onError, setLoading,
      );
    },

    getAlbum(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/songs/album/${id}`),
        then, onError, setLoading,
      );
    },

    getMaybe(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get('/api/songs/maybe'),
        then, onError, setLoading,
      );
    },

    getApproved(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get('/api/songs/approved'),
        then, onError, setLoading,
      );
    },

    getRejected(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get('/api/songs/rejected'),
        then, onError, setLoading,
      );
    },

    postMaybe(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.post(`/api/songs/${id}/maybe`),
        then, onError, setLoading,
      );
    },

    postApproved(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.post(`/api/songs/${id}/approved`),
        then, onError, setLoading,
      );
    },

    postRejected(vue, id, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.post(`/api/songs/${id}/rejected`),
        then, onError, setLoading,
      );
    },

    sendCakeForm(vue, data, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const formData = new FormData();
      Object.keys(data).forEach(key => formData.append(key, data[key]));

      this.processPromise(
        vue.$http.post('/api/forms/cake', formData),
        then, onError, setLoading,
      );
    },

    sendProgrammeForm(vue, data, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const formData = new FormData();
      Object.keys(data).forEach(key => formData.append(key, data[key]));

      this.processPromise(
        vue.$http.post('/api/forms/programme', formData),
        then, onError, setLoading,
      );
    },

    getGalleryAlbums(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get('/api/gallery/albums'),
        then, onError, setLoading,
      );
    },

    getGalleryAlbum(vue, albumId, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/gallery/albums/${albumId}`),
        then, onError, setLoading,
      );
    },

    getGalleryFiles(vue, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get('/api/gallery/photos'),
        then, onError, setLoading,
      );
    },

    getAlbumFiles(vue, albumId, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/gallery/albums/${albumId}/photos`),
        then, onError, setLoading,
      );
    },

    getAlbumTitles(vue, albumIds, mapper = t => t, whenFinished = (titles) => {},
      onError = (error) => {}, setLoading = true, accumulator = {}) {
      if (setLoading) {
        this.loading = true;
      }

      if (albumIds.length === 0) {
        whenFinished(accumulator);
        this.loading = false;
      } else {
        this.getAlbumTitle(vue, albumIds[0], (response) => {
          const accu = { ...accumulator };
          accu[albumIds[0]] = mapper(response.data);
          this.getAlbumTitles(vue, albumIds.slice(1), mapper, whenFinished, onError,
            setLoading, accu);
        }, onError, false);
      }
    },

    getAlbumTitle(vue, albumId, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      this.processPromise(
        vue.$http.get(`/api/gallery/albums/${albumId}/title`),
        then, onError, setLoading,
      );
    },

    uploadRequest(vue, albumId, files, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const data = {
        album_id: albumId,
        number_of_files: files.length,
        content_type: files.map(file => file.type),
      };

      this.processPromise(
        vue.$http.post('/api/gallery/uploads/photos', data),
        then, onError, setLoading,
      );
    },

    uploadFilesToS3(vue, files, uploadGrants, uploadedCallback = () => {}, doneCallback = () => {},
      onError = (error) => {}, setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      if (files.length > 1) {
        this.uploadFileToS3(vue, files[0], uploadGrants[0], (response) => {
          uploadedCallback();

          this.uploadFilesToS3(vue, files.slice(1), uploadGrants.slice(1), uploadedCallback,
            doneCallback, onError, false);
        }, onError, false);
      } else {
        this.uploadFileToS3(vue, files[0], uploadGrants[0], (response) => {
          doneCallback();
        }, onError);
      }
    },

    uploadFileToS3(vue, file, uploadGrant, then = (response) => {}, onError = (error) => {},
      setLoading = true) {
      if (setLoading) {
        this.loading = true;
      }

      const formData = new FormData();
      Object.entries(uploadGrant.fields).forEach(([name, value]) => {
        formData.append(name, value);
      });
      formData.append('file', file);

      this.processPromise(
        vue.$http.post(uploadGrant.url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
        then, onError, setLoading,
      );
    },

    processPromise(promise, then, onError, setLoading) {
      promise.then((response) => {
        if (setLoading) {
          this.loading = false;
        }

        then(response);
      }).catch((error) => {
        this.loading = false;
        onError(error);
      });
    },
  },

  beforeRouteEnter(to, from, next) {
    next();
    Vue.axios.get('/api/invitee')
      .then(response => next((vm) => {
        // eslint-disable-next-line no-param-reassign,prefer-destructuring
        vm.self = response.data[0];
        // eslint-disable-next-line no-param-reassign
        vm.isAdmin = vm.self.is_admin;
      }))
      .catch(() => next({
        name: 'login',
        query: { intent: to.fullPath },
      }));
  },
};
